var _g, _path, _path2, _path3, _path4, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLightBlue = function SvgLightBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddii_lightBlue)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4443 94.8889C74.9903 94.8889 94.8888 74.9904 94.8888 50.4444C94.8888 25.8985 74.9903 6 50.4443 6C25.8983 6 5.99988 25.8985 5.99988 50.4444C5.99988 74.9904 25.8983 94.8889 50.4443 94.8889Z",
    fill: "#E3C19A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.5508 50.4462C90.5508 28.2928 72.5919 10.3338 50.4384 10.3338C28.285 10.3338 10.326 28.2928 10.326 50.4462C10.326 72.5997 28.285 90.5586 50.4384 90.5586C72.5919 90.5586 90.5508 72.5997 90.5508 50.4462Z",
    fill: "#FBF4ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4438 88.0373C71.2058 88.0373 88.0367 71.2064 88.0367 50.4445C88.0367 29.6825 71.2058 12.8516 50.4438 12.8516C29.6819 12.8516 12.851 29.6825 12.851 50.4445C12.851 71.2064 29.6819 88.0373 50.4438 88.0373Z",
    fill: "url(#paint0_linear_lightBlue)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6873 51.7693C28.3665 55.1226 38.0457 56.3189 47.2898 51.7693C56.534 47.2198 69.7296 44.229 77.433 45.2259C80.0504 45.6157 82.6413 46.1666 85.1909 46.8754C83.9971 38.1906 79.5862 30.2705 72.8311 24.683C66.0761 19.0955 57.4695 16.2478 48.7149 16.7036C39.9603 17.1595 31.6959 20.8856 25.5577 27.1445C19.4196 33.4034 15.855 41.7387 15.5697 50.5005C16.4579 50.9537 17.491 51.3162 18.6873 51.7693Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8755 60.3771C22.6214 74.0076 36.2338 85.1731 50.3357 85.1731C60.2505 85.0644 71.1441 79.6085 76.2918 72.7751C78.1044 65.1623 62.0631 74.3158 50.3357 74.1708C35.7626 74.4789 20.2106 53.6524 16.8755 60.3771Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddii_lightBlue",
    x: -0.00012207,
    y: 0.5,
    width: 100.889,
    height: 99.8889,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.227451 0 0 0 0 0.0666667 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.227451 0 0 0 0 0.0666667 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.227451 0 0 0 0 0.0666667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.227451 0 0 0 0 0.0666667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow",
    result: "effect4_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_lightBlue",
    x1: 49.8457,
    y1: 15.2985,
    x2: 51.0239,
    y2: 83.3609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DFF"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLightBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lightBlue.f77d1523.svg";
export { ForwardRef as ReactComponent };